import { CertificationCompletionEntry } from 'types/admin/analytics';

export const getCertificationTrendChartData = (
  completions: [string, CertificationCompletionEntry][],
  chartColors: string[],
  months: { year: number; month: number; label: string }[]
) => {
  const chartData = {
    labels: months.map((m) => m.label),
    datasets: completions.map(([, entry], index) => ({
      label: entry.certificationName,
      data: sumUserCountsByMonth(months, entry),
      borderColor: chartColors[index],
      backgroundColor: chartColors[index],
      tension: 0.3,
      pointRadius: 4,
    })),
  };
  return chartData;
};

export const sumUserCountsByMonth = (months: { year: number; month: number }[], entry: CertificationCompletionEntry) =>
  months
    .map(({ year, month }) =>
      Object.entries(entry.userCountsByDate).reduce((sum, [dateStr, count]) => {
        const d = new Date(dateStr);
        return d.getUTCFullYear() === year && d.getUTCMonth() === month ? sum + count : sum;
      }, 0)
    )
    .reduce<number[]>((acc, val) => {
      acc.push((acc[acc.length - 1] ?? 0) + val);
      return acc;
    }, []);

export const getUserCountFrom30DaysAgo = (entry: CertificationCompletionEntry) => {
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  const userCount = Object.entries(entry.userCountsByDate)
    .filter(([dateStr]) => new Date(dateStr) <= thirtyDaysAgo)
    .reduce((sum, [, count]) => sum + count, 0);
  return userCount;
};
